import { render, staticRenderFns } from "./CustomerContractPricing.vue?vue&type=template&id=065dbe0c&"
import script from "./CustomerContractPricing.vue?vue&type=script&lang=js&"
export * from "./CustomerContractPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports